export {default} from '../../../core/components/Repository/FieldVideo';
